import { render, staticRenderFns } from "./AboutMapPage.vue?vue&type=template&id=40aadb8e&scoped=true&"
import script from "./AboutMapPage.vue?vue&type=script&lang=js&"
export * from "./AboutMapPage.vue?vue&type=script&lang=js&"
import style0 from "./AboutMapPage.vue?vue&type=style&index=0&id=40aadb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aadb8e",
  null
  
)

export default component.exports